import React from "react";
import ReactDOM from "react-dom";
import { App } from "./app";

const main = () => {
  ReactDOM.render(<App />, document.getElementById("app"));
};

main();